import {AnalyticsParameterValue} from 'insights/parameters/__generated/AnalyticsParameterValue';
import pickDefined from 'util/pickDefined';
import {JSONValue} from 'util/Types';

import {AnalyticsParameterConfigGraphQL as AnalyticsParameterConfig} from '../../../../graphql-fragments/insights/__generated/AnalyticsParameterConfigGraphQL';

export default function getParameterValueObject(
  config: Pick<AnalyticsParameterConfig, '__typename' | 'id'>,
  valueJson: JSONValue
): AnalyticsParameterValue {
  return {
    config: pickDefined(config, '__typename', 'id'),
    __typename: 'AnalyticsParameterValueNode',
    valueJson,
  };
}
